import { render, staticRenderFns } from "./GrooveMailFormVariants.vue?vue&type=template&id=7bbf5d12"
import script from "./GrooveMailFormVariants.vue?vue&type=script&lang=js"
export * from "./GrooveMailFormVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports